/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Missing_BadgeInputs */

const en_us2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 answer missing`);
	return /** @type {LocalizedString} */ (`${i?.count} answers missing`)
	
};

const pt_br2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 resposta faltando`);
	return /** @type {LocalizedString} */ (`${i?.count} respostas faltando`)
	
};

const es_419_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 respuesta`);
	return /** @type {LocalizedString} */ (`Faltan ${i?.count} respuestas`)
	
};

const pt_pt2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 resposta`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} respostas`)
	
};

const fr_fr2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 réponse manquante`);
	return /** @type {LocalizedString} */ (`${i?.count} réponses manquantes`)
	
};

const de_de2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Antwort fehlt`);
	return /** @type {LocalizedString} */ (`${i?.count} Antworten fehlen`)
	
};

const it_it2_profile_missing_badge = /** @type {(inputs: Profile_Missing_BadgeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Manca 1 risposta`);
	return /** @type {LocalizedString} */ (`Mancano ${i?.count} risposte`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 answer missing" |
* | * | "{count} answers missing" |
*
* @param {Profile_Missing_BadgeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_missing_badge = /** @type {((inputs: Profile_Missing_BadgeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Missing_BadgeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_missing_badge(inputs)
	if (locale === "es-419") return es_419_profile_missing_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_missing_badge(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_missing_badge(inputs)
	if (locale === "de-DE") return de_de2_profile_missing_badge(inputs)
	if (locale === "it-IT") return it_it2_profile_missing_badge(inputs)
	return en_us2_profile_missing_badge(inputs)
});
export { profile_missing_badge as "profile.missing_badge" }